import { ProjectContext } from "context/ProjectProvider";
import { useCIQMutation } from "hooks/ciq-gql-hooks";
import { useContext, useState } from "react";
import { MUTATION_SEND_FEATURE_WF_INVITE } from "services/graphQL/mutations";
import { IMaterial } from "../type-definitions";
import useRequestDurationsDataProvider from "./request-duations-old-new-model-data-provider";

export function useRequestDurations(materialIds: string[]): {
  data: { feature_instance: IMaterial[] } | null;
  loading: boolean;
  sendInvite: (variables: any) => Promise<any>;
  sendingInvite: boolean;
} {
  const { gqlClientForProject } = useContext(ProjectContext);

  const [sendingInvite, setSendingInvite] = useState(false);

  const { data, loading } = useRequestDurationsDataProvider(materialIds);

  const [sendFeatureWFInvite] = useCIQMutation(
    MUTATION_SEND_FEATURE_WF_INVITE,
    {
      client: gqlClientForProject
    }
  );

  const sendInvite = async (variables: any) => {
    setSendingInvite(true);
    const response = await sendFeatureWFInvite({ variables });
    setSendingInvite(false);
    return response;
  };

  return {
    data: data || null,
    loading,
    sendInvite,
    sendingInvite
  };
}
